import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

import jwtDecode from 'jwt-decode';
import {
  getAccessTokenApi,
  getRefreshTokenApi,
  guardarTokens,
  logout,
  refreshAccessTokenApi,
} from '../api/auth';
import { usePAppApi } from 'hooks/useAppApi';
import { PERFIL_ACTIVO_KEY } from 'utils/constants';

// export const logoutAction = () => {
//   logout();
//   navigate('/login');
//   // window.location.href = '/login';
// };

const checkUserLogin = async (setUser) => {
  const accessToken = await getAccessTokenApi();
  if (!accessToken) {
    const refreshToken = await getRefreshTokenApi();

    if (!refreshToken) {
      logout();
      setUser({
        isLoading: false,
        user: null,
      });
    } else if (await refreshAccessTokenApi(refreshToken)) {
      setUser({
        isLoading: false,
        user: jwtDecode(await getAccessTokenApi()),
      });
    }
  } else {
    setUser({
      isLoading: false,
      user: jwtDecode(accessToken),
    });
  }
};

export const AuthContext = createContext();

function AuthProvider(props) {
  const { children } = props;
  const [user, setUser] = useState({
    user: null,
    isLoading: true,
  });
  const [perfilActivo, setPerfilActivoState] = useState(
    () => sessionStorage.getItem(PERFIL_ACTIVO_KEY) || null
  );
  const setPerfilActivo = useCallback((p) => {
    sessionStorage.setItem(PERFIL_ACTIVO_KEY, p);
    setPerfilActivoState(p);
  }, []);
  useEffect(() => {
    if (user.isLoading) {
      checkUserLogin(setUser);
    }
  }, [user]);

  const updateUserData = () => {
    setUser({
      isLoading: true,
      user: null,
    });
  };

  const mapChange = useCallback((response) => {
    return response;
  }, []);

  const {
    error: errorChangePass,
    isLoading: loadingPass,
    call: callChangePass,
  } = usePAppApi({
    url: '/user/change-password',
    mapResults: mapChange,
  });

  const changePassword = async (values) => {
    // Sin `rut`: a quién se le cambia la contraseña lo decide el token en el backend, y el
    // endpoint rechaza el campo. Mandarlo sugeriría que el cliente elige el objetivo.
    const response = await callChangePass({
      password: values.password,
      actual: values.actual,
    });
    // Cambiar la contraseña revoca las sesiones de la cuenta, también esta: la API devuelve
    // tokens nuevos y hay que guardarlos o el próximo request cae a login.
    guardarTokens(response);
    return response;
  };

  const providerData = useMemo(() => {
    const type = user?.user?.type;
    const perfiles =
      Array.isArray(user?.user?.perfiles) && user.user.perfiles.length
        ? user.user.perfiles
        : type
        ? [type]
        : [];
    // El sombrero default: el último usado si sigue siendo válido, si no el type.
    const activo = perfiles.includes(perfilActivo) ? perfilActivo : type;
    return {
      ...user,
      user: {
        ...user?.user,
        perfiles,
        is_administrador: type === 'administrador',
        is_ejecutivo: perfiles.includes('ejecutivo'),
        is_supervisor: perfiles.includes('supervisor'),
        is_liftlogic: type === 'liftlogic',
        is_especialista: perfiles.includes('especialista'),
      },
      perfilActivo: activo,
      setPerfilActivo,
      checkUserLogin,
      updateUserData,
      changePassword,
      loadingPass,
    };
  }, [user, perfilActivo, setPerfilActivo, loadingPass]);

  return <AuthContext.Provider value={providerData}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
